module.exports = __webpack_public_path__ + "img/google.8f3c75b4.png";